import { BoostUserSchemaRole } from "@/upsmith-api";

export const isAdmin = (currentUser: { role: BoostUserSchemaRole }) => {
  return (
    currentUser?.role === BoostUserSchemaRole.admin ||
    currentUser?.role === BoostUserSchemaRole.admin_technician
  );
};
